export const extractPath = (url: URL) => {
  return url.toString().substring(url.origin.length);
};
